import React, {
    ReactElement,
    useCallback,
    useContext,
    useLayoutEffect,
    useMemo,
    useRef,
    useState,
} from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import ArrowDropDownIcon from '@mui/icons-material/ChevronRight';
import {
    Box,
    Typography,
    Collapse,
    FormControl,
    FormLabel,
    RadioGroup,
    Grid,
    FormGroup,
    TextField,
    Stack,
    ButtonGroup,
    Tooltip,
    IconButton,
} from '@mui/material';
import {
    AppRadioBox,
    AppFormikTextField,
    AppPrimaryButton,
    AppOutlinedRadioInput,
    AppFormikTextFieldNumber,
    AppFormikDatePicker,
    ButtonComp,
} from 'shared/components/AppComponents';
import { Formik, FormikHelpers, FormikProps } from 'formik';
import { sendRequest } from 'modules/home/manage-packets/listing-packets/components/data/fetch';
import { checkboxStatus } from 'modules/home/manage-packets/listing-packets/components/data/checkboxStatus';
import { checkboxType } from 'modules/home/manage-packets/listing-packets/components/data/checkboxType';

import {
    BaseAppActions,
    setSidebarDashboard,
} from 'state/baseapplication/Action';
import { TemplateService } from 'services';
import { Toast, Utils } from 'shared/helpers';
import { ProfileActions } from 'state/profile/Action';
import DateFnsAdapter from '@date-io/date-fns';
import ShareTemplateFormDialog from './ShareTemplateFormDialog';
import ResetShareTemplateFormDialog from './ResetTemplateFormDialog';
import { useFormikValidationEffect } from 'shared/helpers/Formik';
import InfoIcon from '@mui/icons-material/Info';
import { useHarmonicIntervalFn, useUpdateEffect } from 'react-use';
import { abortProtocol } from 'modules/home/manage-packets/listing-packets/components/data/Main';
import { APIManager } from 'shared/manager/APIManager';
import OverrideGlobalSavingModal, {
    inferGlobalSavingModal,
} from './OverrideGlobalSavingModal';
import { DashboardMeta } from 'modules/authentication/components/DashboardPage';
import { AxiosError } from 'axios';

const dateFns = new DateFnsAdapter();

const FilterSidebar = ({
    handleChangeSortBy,
    handleChangeSearchBy,
    updateData,
    handleChangePacketStatus,
    handleChangePacketType,
    formikRef,
    state,
    setState,
    handleReset,
    profileState,
}: FilterSidebar): ReactElement => {
    const dispatch = useDispatch();
    const role = useSelector((state: any) => state.authState.role);
    const userInfo = useSelector((state: any) => state.profileState.userInfo);
    const formikTilesRef = useRef<FormikProps<FormikTilesPropsValues> | null>(
        null
    );
    const overrideModal = useRef<inferGlobalSavingModal | null>(null);
    const [isSavingGloballyTemplate, setSavingGloballyTemplate] =
        useState<boolean>(false);

    const [isResetGloballyTemplate, setResetGloballyTemplate] =
        useState<boolean>(false);
    const DashboardMetaProps = useContext(DashboardMeta);
    // const [, setResetCustomTemplate] = useState<boolean>(false);

    const [checkedByLoan, setByLoan] = useState<boolean>(false);
    const [checkedByBin, setByBin] = useState<boolean>(false);
    const [checkedByClient, setByClient] = useState<boolean>(false);
    const [checkedByOperator, setByOperator] = useState<boolean>(false);
    const [checkedByCM9, setByCM9] = useState<boolean>(false);
    const [checkedByUploadDate, setByUploadDate] = useState<boolean>(false);
    const [checkedByCompletedDate, setByCompletedDate] =
        useState<boolean>(false);
    const [checkedBySLADate, setBySLADate] = useState<boolean>(false);
    const [checkedByUploadAge, setByUploadAge] = useState<boolean>(false);
    const [openSortByMenu, setOpenSortByMenu] = useState(!!state.sortBy);
    const [openSearchByMenu, setOpenSearchMenu] = useState(!!state.searchBy);
    const [openFilterByPacketStatusMenu, setOpenFilterPacketStatusMenu] =
        useState(
            !!(
                Array.isArray(state.packetStatus) &&
                state.packetStatus.length > 0
            )
        );

    const [openFilterByPacketTypeMenu, setOpenFilterPacketTypeMenu] = useState(
        !!(Array.isArray(state.packetType) && state.packetType.length > 0)
    );
    const [openGloballyTemplate] = useState<boolean>(true);
    const [openCustomTemplate] = useState<boolean>(true);
    const [showShareTemplateDialog, setShowShareTemplateDialog] =
        useState<boolean>(false);
    const [showResetShareTemplateDialog, setShowResetShareTemplateDialog] =
        useState<boolean>(false);
    const [isSubmitting, setSubmitting] = useState<boolean>(false);
    const [isSubmit, setSubmit] = useState<boolean>(false);

    const handleRevocation = useCallback(() => {
        setSubmitting(true);
        setSubmit(false);
    }, []);

    useUpdateEffect(() => {
        if (isSubmit === true) {
            if (abortProtocol.protocol) {
                // check any active request
                APIManager.target.addEventListener(
                    'revocation',
                    handleRevocation
                );
            }
            setSubmitting(true);
            setSubmit(false);
        } else if (state.isLoading === false) {
            setSubmitting(state.isLoading);
            APIManager.target.removeEventListener(
                'revocation',
                handleRevocation
            );
        }
    }, [state.isLoading, isSubmit]);

    const [isReseting, setResetSearch] = React.useState<boolean>(false);
    useHarmonicIntervalFn(
        () => {
            const { current: formik } = formikRef;
            if (formik) {
                formik.setValues(
                    {
                        search_loan: '',
                        search_bin: '',
                        search_client: '',
                        search_operator: '',
                        search_cm9: '',
                        search_datepicker_uploaddate: '',
                        search_datepicker_completeddate: '',
                        search_sladate: '',
                        search_uploadage: '',
                    },
                    true
                );
            }
            setResetSearch(false);
        },
        isReseting ? 500 : null
    );
    /**
     * Reset searh in the form
     * @summary function to call reset value in the form
     */
    const resetSearch = React.useCallback((): void => {
        const { current: formik } = formikRef;
        if (formik) {
            setByLoan(false);
            setByBin(false);
            setByClient(false);
            setByOperator(false);
            setByCM9(false);
            setByUploadDate(false);
            setByUploadAge(false);
            setByCompletedDate(false);
            setBySLADate(false);

            formik.setFieldValue('search_loan', '', true);
            formik.setFieldValue('search_bin', '', true);
            formik.setFieldValue('search_client', '', true);
            formik.setFieldValue('search_operator', '', true);
            formik.setFieldValue('search_cm9', '', true);
            formik.setFieldValue('search_datepicker_uploaddate', '', true);
            formik.setFieldValue('search_datepicker_completeddate', '', true);
            formik.setFieldValue('search_sladate', '', true);
            formik.setFieldValue('search_uploadage', '', true);
            setResetSearch(true);
        }
    }, [formikRef]);

    /**
     * Handle changes to reflect in redux state
     *
     */
    React.useLayoutEffect(() => {
        dispatch(
            setSidebarDashboard({
                textField: state.textField,
                searchBy: state.searchBy,
                sortBy: state.sortBy,
                packetStatus: state.packetStatus,
                packetType: state.packetType,
                binNumber: formikRef.current.values.search_bin,
                clientName: formikRef.current.values.search_client,
                cm9Number: formikRef.current.values.search_cm9,
                loanNumber: formikRef.current.values.search_loan,
                operatorId: formikRef.current.values.search_operator,
                rowsPerPage: state.rowsPerPage,
                slaDaysLeft:
                    Number.isNaN(
                        parseInt(formikRef.current.values.search_sladate, 10)
                    ) === false
                        ? parseInt(formikRef.current.values.search_sladate, 10)
                        : '',
                completedDate:
                    formikRef.current.values.search_datepicker_completeddate,
                uploadAge:
                    Number.isNaN(
                        parseInt(formikRef.current.values.search_uploadage, 10)
                    ) === false
                        ? parseInt(
                              formikRef.current.values.search_uploadage,
                              10
                          )
                        : '',
                uploadDate:
                    formikRef.current.values.search_datepicker_uploaddate,
            })
        );
    }, [
        checkedByLoan,
        checkedByBin,
        checkedByClient,
        checkedByOperator,
        checkedByCM9,
        checkedByUploadAge,
        checkedByUploadDate,
        checkedBySLADate,
        checkedByCompletedDate,
        state.searchBy,
        state.isUpdateTextField,
        state.sortBy,
        state.packetStatus,
        state.packetType,
        state.rowsPerPage,
        dispatch,
        formikRef,
        state.textField,
    ]);

    /**
     * Handle changes request filter dashboard
     *
     * @param {string} textfield - 'the content textfield sidebar'
     * @param {string} formik - 'the content formik sidebar'
     */
    const reqFilterPacket = (
        textfieldLoan: string,
        textfieldBin: string,
        textfieldClient: string,
        textfieldOperator: string,
        textfieldCM9: string,
        textfieldUploadDate: string,
        textfieldCompletedDate: string,
        textfieldSLALeft: number,
        textfieldUploadAge: number,
        formik: FormikHelpers<any> | boolean
    ): void => {
        setState((prevState: any) => ({
            ...prevState,
            isUpdateTextField: true,
            isLoading: true,
            searchValues: {
                ...prevState.searchValues,
                binNumber: textfieldBin,
                clientName: textfieldClient,
                loanNumber: textfieldLoan,
                operatorId: textfieldOperator,
            },
        }));
        sendRequest(
            textfieldLoan,
            textfieldBin,
            textfieldClient,
            textfieldOperator,
            textfieldCM9,
            textfieldUploadDate,
            textfieldCompletedDate,
            textfieldSLALeft,
            textfieldUploadAge,
            state.sortBy,
            formik,
            1,
            state.rowsPerPage ?? 10,
            state.packetStatus,
            state.packetType,
            (
                e: any[],
                totalRows: number,
                formik: any,
                isNetworkError: boolean
            ) => {
                updateData(e, totalRows, formik, isNetworkError);
                setState((prevState: any) => ({
                    ...prevState,
                    isLoading: false,
                    isUpdateTextField: false,
                }));
            }
        );
    };

    // UI Actions
    const actionOnShareTemplate = (): void => {
        if (
            userInfo.customDashboardTemplateEnabled &&
            userInfo.globalDashboardTemplateEnabled &&
            role !== 'clientManager'
        ) {
            Toast.showInfoMessage(
                'Global filtration Template is currently active. Please contact the Checklists Manager for further information.'
            );
        }
        if (
            (userInfo.customDashboardTemplateEnabled &&
                !userInfo.globalDashboardTemplateEnabled) ||
            role === 'clientManager'
        ) {
            setShowShareTemplateDialog(true);
        }
    };

    const onCloseShareTemplate = (): void => {
        setShowShareTemplateDialog(false);
    };

    const onCloseResetShareTemplate = (): void => {
        setShowResetShareTemplateDialog(false);
    };
    /**
     * variable to use in disabled button for share template
     */
    const isShareTemplateAllowed = React.useMemo((): boolean => {
        if (
            userInfo.globalDashboardTemplateEnabled ||
            userInfo.customDashboardTemplateEnabled === false
        ) {
            return true;
        }
        return false;
    }, [
        userInfo.customDashboardTemplateEnabled,
        userInfo.globalDashboardTemplateEnabled,
    ]);

    /**
     * variable to use in disabled button for globally share template
     */
    // const isGloballyTemplateAllowed = React.useMemo((): boolean => {
    //     if (isSavingGloballyTemplate) {
    //         return true;
    //     }

    //     if (
    //         (!userInfo.customDashboardTemplateEnabled &&
    //             !userInfo.globalDashboardTemplateEnabled) ||
    //         (!userInfo.customDashboardTemplateEnabled &&
    //             userInfo.globalDashboardTemplateEnabled)
    //     ) {
    //         return true;
    //     }

    //     return false;
    // }, [
    //     isSavingGloballyTemplate,
    //     userInfo.customDashboardTemplateEnabled,
    //     userInfo.globalDashboardTemplateEnabled,
    // ]);

    const [isRippleFormikState, setRippleFormikState] =
        React.useState<boolean>(false);

    /**
     * variable to check changed formik values based on inputed validation
     */
    const FormikValues = React.useMemo(
        () => (formikRef.current ? formikRef.current.values : null),
        [formikRef.current, isRippleFormikState]
    );
    useFormikValidationEffect(
        () => {
            if (checkedByBin) setRippleFormikState(true);
        },
        'search_bin',
        formikRef
    );
    useFormikValidationEffect(
        () => {
            if (checkedByCM9) setRippleFormikState(true);
        },
        'search_cm9',
        formikRef
    );
    useFormikValidationEffect(
        () => {
            if (checkedByClient) setRippleFormikState(true);
        },
        'search_client',
        formikRef
    );

    useFormikValidationEffect(
        () => {
            if (checkedByLoan) setRippleFormikState(true);
        },
        'search_loan',
        formikRef
    );
    useFormikValidationEffect(
        () => {
            if (checkedByOperator) setRippleFormikState(true);
        },
        'search_operator',
        formikRef
    );
    useFormikValidationEffect(
        () => {
            if (checkedBySLADate) setRippleFormikState(true);
        },
        'search_sladate',
        formikRef
    );

    useFormikValidationEffect(
        () => {
            if (checkedByUploadAge) setRippleFormikState(true);
        },
        'search_uploadage',
        formikRef
    );

    /**
     * set the ripple effect on validation input
     */
    useLayoutEffect(() => {
        if (isRippleFormikState) setRippleFormikState(false);
    }, [isRippleFormikState]);

    /**
     * variable to use in disabled button for saving template
     */
    const isAbleSavingTemplate = useMemo(
        () =>
            (typeof state.sortBy === 'string' && state.sortBy !== '') ||
            (typeof state.packetStatus === 'object' &&
                Array.isArray(state.packetStatus) &&
                state.packetStatus.length > 0) ||
            (typeof state.packetType &&
                Array.isArray(state.packetType) &&
                state.packetType.length > 0) ||
            (FormikValues !== null &&
                ((checkedByBin &&
                    typeof FormikValues.search_bin === 'string' &&
                    FormikValues.search_bin !== '') ||
                    (checkedByCM9 &&
                        typeof FormikValues.search_cm9 === 'string' &&
                        FormikValues.search_cm9 !== '') ||
                    (checkedByClient &&
                        typeof FormikValues.search_client === 'string' &&
                        FormikValues.search_client !== '') ||
                    (checkedByCompletedDate &&
                        ((typeof FormikValues.search_datepicker_completeddate ===
                            'string' &&
                            FormikValues.search_datepicker_completeddate !==
                                '') ||
                            (typeof FormikValues.search_datepicker_completeddate ===
                                'object' &&
                                FormikValues.search_datepicker_completeddate instanceof
                                    Date))) ||
                    (checkedByLoan &&
                        typeof FormikValues.search_loan === 'string' &&
                        FormikValues.search_loan !== '') ||
                    (checkedByOperator &&
                        typeof FormikValues.search_operator === 'string' &&
                        FormikValues.search_operator !== '') ||
                    (checkedBySLADate &&
                        FormikValues.search_sladate !== 0 &&
                        typeof FormikValues.search_sladate === 'number' &&
                        Number.isNaN(FormikValues.search_sladate) === false) ||
                    (checkedByUploadDate &&
                        ((typeof FormikValues.search_datepicker_uploaddate ===
                            'string' &&
                            FormikValues.search_datepicker_uploaddate !== '') ||
                            (typeof FormikValues.search_datepicker_uploaddate ===
                                'string' &&
                                FormikValues.search_datepicker_uploaddate instanceof
                                    Date))) ||
                    (checkedByUploadAge &&
                        FormikValues.search_uploadage !== 0 &&
                        typeof FormikValues.search_uploadage === 'number' &&
                        Number.isNaN(FormikValues.search_uploadage) ===
                            false))),
        [
            state.sortBy,
            state.packetStatus,
            state.packetType,
            checkedByBin,
            FormikValues,
            checkedByCM9,
            checkedByClient,
            checkedByCompletedDate,
            checkedByLoan,
            checkedByOperator,
            checkedBySLADate,
            checkedByUploadDate,
            checkedByUploadAge,
            isRippleFormikState,
        ]
    );

    /**
     * check effect for active input based from formik setted value
     */
    React.useLayoutEffect(() => {
        if (FormikValues && isReseting === false) {
            if (
                typeof FormikValues.search_loan === 'string' &&
                FormikValues.search_loan !== '' &&
                checkedByLoan === false
            ) {
                setByLoan(true);
            }
            if (
                typeof FormikValues.search_client === 'string' &&
                FormikValues.search_client !== '' &&
                checkedByClient === false
            ) {
                setByClient(true);
            }
            if (
                typeof FormikValues.search_bin === 'string' &&
                FormikValues.search_bin !== '' &&
                checkedByBin === false
            ) {
                setByBin(true);
            }
            if (
                typeof FormikValues.search_operator === 'string' &&
                FormikValues.search_operator !== '' &&
                checkedByOperator === false
            ) {
                setByOperator(true);
            }
            if (
                typeof FormikValues.search_cm9 === 'string' &&
                FormikValues.search_cm9 !== '' &&
                checkedByCM9 === false
            ) {
                setByCM9(true);
            }
            if (
                typeof FormikValues.search_datepicker_uploaddate === 'string' &&
                FormikValues.search_datepicker_uploaddate !== '' &&
                checkedByUploadDate === false
            ) {
                setByUploadDate(true);
            }
            if (
                typeof FormikValues.search_datepicker_completeddate ===
                    'string' &&
                FormikValues.search_datepicker_completeddate !== '' &&
                checkedByCompletedDate === false
            ) {
                setByCompletedDate(true);
            }

            if (
                FormikValues.search_sladate !== 0 &&
                typeof FormikValues.search_sladate === 'number' &&
                Number.isNaN(FormikValues.search_sladate) === false &&
                checkedBySLADate === false
            ) {
                setBySLADate(true);
            }

            if (
                FormikValues.search_uploadage !== 0 &&
                typeof FormikValues.search_uploadage === 'number' &&
                Number.isNaN(FormikValues.search_uploadage) === false &&
                checkedByUploadAge === false
            ) {
                setByUploadAge(true);
            }
        }
    }, [FormikValues]);

    const [isSavingTemplate, setSavingTemplate] = useState<boolean>(false);

    /**
     * handle save template
     */
    const handleSaveTemplate = React.useCallback(() => {
        if (
            userInfo.globalDashboardTemplateEnabled &&
            role !== 'clientManager'
        ) {
            Toast.showInfoMessage(
                'Global filtration Template is currently active. Please contact the Client Manager for further information.'
            );
        } else {
            setSavingTemplate(true);
            const searchByuploadDate =
                formikRef.current.values.search_datepicker_uploaddate;
            const searchBycompletedDate =
                formikRef.current.values.search_datepicker_completeddate;
            const searchFromUploadDate = new Date(searchByuploadDate);
            const searchFromCompletedDate = new Date(searchBycompletedDate);

            const stringUploadDate =
                Number.isNaN(Date.parse(searchByuploadDate)) === false &&
                typeof searchByuploadDate !== 'number'
                    ? dateFns.formatByString(searchFromUploadDate, 'yyyy-MM-dd')
                    : null;
            const stringCompletedDate =
                Number.isNaN(Date.parse(searchBycompletedDate)) === false &&
                typeof searchBycompletedDate !== 'number'
                    ? dateFns.formatByString(
                          searchFromCompletedDate,
                          'yyyy-MM-dd'
                      )
                    : null;

            TemplateService.saveSavedTemplate({
                query: {
                    offset:
                        state.reduxInitValues.offset &&
                        typeof state.reduxInitValues.offset === 'number'
                            ? state.reduxInitValues.offset
                            : 1,
                    limit:
                        state.rowsPerPage &&
                        typeof state.rowsPerPage === 'number'
                            ? state.rowsPerPage
                            : 10,
                    sort: state.sortBy ? state.sortBy : undefined,
                    packetStatus:
                        Array.isArray(state.packetStatus) &&
                        state.packetStatus.length > 0
                            ? state.packetStatus
                            : undefined,
                    packetType:
                        Array.isArray(state.packetType) &&
                        state.packetType.length > 0
                            ? state.packetType
                            : undefined,
                    loanNumber: formikRef.current.values.search_loan
                        ? formikRef.current.values.search_loan
                        : undefined,
                    binNumber: formikRef.current.values.search_bin
                        ? formikRef.current.values.search_bin
                        : undefined,
                    operatorId: formikRef.current.values.search_operator
                        ? formikRef.current.values.search_operator
                        : undefined,
                    cm9Number: formikRef.current.values.search_cm9
                        ? formikRef.current.values.search_cm9
                        : undefined,
                    clientName: formikRef.current.values.search_client
                        ? formikRef.current.values.search_client
                        : undefined,
                    uploadDate:
                        stringUploadDate !== null
                            ? stringUploadDate
                            : undefined,
                    completedDate:
                        stringCompletedDate !== null
                            ? stringCompletedDate
                            : undefined,
                    slaDaysLeft: checkedBySLADate
                        ? formikRef.current.values.search_sladate
                        : undefined,
                    uploadAge: checkedByUploadAge
                        ? formikRef.current.values.search_uploadage
                        : undefined,
                },
                type: 'custom',
            })
                .then((response) => {
                    dispatch(
                        ProfileActions.setTemplateId(
                            response.data.data.templateId
                        )
                    );

                    dispatch(BaseAppActions.resetSidebarDashboardTheme(true));
                    setSavingTemplate(false);
                    Utils.handleSuccessResponse(response);
                })
                .catch((response) => {
                    setSavingTemplate(false);
                    if (
                        response !== null &&
                        response instanceof AxiosError &&
                        response.code === 'ERR_NETWORK'
                    ) {
                        Toast.showErrorMessage(
                            'No internet connection, Please try again!'
                        );
                    } else {
                        Utils.handleErrorResponse(response);
                    }
                });
        }
    }, [
        checkedBySLADate,
        checkedByUploadAge,
        dispatch,
        formikRef,
        role,
        state.packetStatus,
        state.packetType,
        state.reduxInitValues.offset,
        state.rowsPerPage,
        state.sortBy,
        userInfo.globalDashboardTemplateEnabled,
    ]);

    const handleOverrideGloballySaveTemplate = React.useCallback(() => {
        setSavingGloballyTemplate(true);

        const searchByuploadDate =
            formikRef.current.values.search_datepicker_uploaddate;
        const searchBycompletedDate =
            formikRef.current.values.search_datepicker_completeddate;
        const searchFromUploadDate = new Date(searchByuploadDate);
        const searchFromCompletedDate = new Date(searchBycompletedDate);

        const stringUploadDate =
            Number.isNaN(Date.parse(searchByuploadDate)) === false &&
            typeof searchByuploadDate !== 'number'
                ? dateFns.formatByString(searchFromUploadDate, 'yyyy-MM-dd')
                : null;
        const stringCompletedDate =
            Number.isNaN(Date.parse(searchBycompletedDate)) === false &&
            typeof searchBycompletedDate !== 'number'
                ? dateFns.formatByString(searchFromCompletedDate, 'yyyy-MM-dd')
                : null;

        TemplateService.saveSavedTemplate({
            query: {
                offset:
                    state.reduxInitValues.offset &&
                    typeof state.reduxInitValues.offset === 'number'
                        ? state.reduxInitValues.offset
                        : 1,
                limit:
                    state.rowsPerPage && typeof state.rowsPerPage === 'number'
                        ? state.rowsPerPage
                        : 10,
                sort: state.sortBy ? state.sortBy : undefined,
                packetStatus:
                    Array.isArray(state.packetStatus) &&
                    state.packetStatus.length > 0
                        ? state.packetStatus
                        : undefined,
                packetType:
                    Array.isArray(state.packetType) &&
                    state.packetType.length > 0
                        ? state.packetType
                        : undefined,
                loanNumber: formikRef.current.values.search_loan
                    ? formikRef.current.values.search_loan
                    : undefined,
                binNumber: formikRef.current.values.search_bin
                    ? formikRef.current.values.search_bin
                    : undefined,
                operatorId: formikRef.current.values.search_operator
                    ? formikRef.current.values.search_operator
                    : undefined,
                cm9Number: formikRef.current.values.search_cm9
                    ? formikRef.current.values.search_cm9
                    : undefined,
                clientName: formikRef.current.values.search_client
                    ? formikRef.current.values.search_client
                    : undefined,
                uploadDate:
                    stringUploadDate !== null ? stringUploadDate : undefined,
                completedDate:
                    stringCompletedDate !== null
                        ? stringCompletedDate
                        : undefined,
                slaDaysLeft: checkedBySLADate
                    ? formikRef.current.values.search_sladate
                    : undefined,
                uploadAge: checkedByUploadAge
                    ? formikRef.current.values.search_uploadage
                    : undefined,
            },
            type: 'global',
        })
            .then((response) => {
                const {
                    data: { data: contentTemplate },
                } = response;
                const { templateId: contentTemplateId } = contentTemplate;
                dispatch(
                    ProfileActions.setGloballyTemplateId(contentTemplateId)
                );
                setSavingGloballyTemplate(false);
                Utils.handleSuccessResponse(response);
            })
            .catch((response) => {
                setSavingGloballyTemplate(false);
                if (
                    response !== null &&
                    response instanceof AxiosError &&
                    response.code === 'ERR_NETWORK'
                ) {
                    Toast.showErrorMessage(
                        'No internet connection, Please try again!'
                    );
                } else {
                    Utils.handleErrorResponse(response);
                }
            });
    }, [
        checkedBySLADate,
        checkedByUploadAge,
        dispatch,
        formikRef,
        state.packetStatus,
        state.packetType,
        state.reduxInitValues.offset,
        state.rowsPerPage,
        state.sortBy,
    ]);
    /**
     * handle globally save template
     */
    const handleGloballySaveTemplate = React.useCallback(() => {
        if (userInfo.globalDashboardTemplateEnabled) {
            const { current: modal } = overrideModal;
            modal?.setOpen();
            Toast.showInfoMessage(
                'Global filtration Template is currently active. '
                // Please contact the Client Manager for further information.'
            );
        } else if (isAbleSavingTemplate === false) {
            Toast.showInfoMessage(
                'Template is currently unchanged in filteration. '
                // Please contact the Client Manager for further information.'
            );
        } else {
            setSavingGloballyTemplate(true);

            const searchByuploadDate =
                formikRef.current.values.search_datepicker_uploaddate;
            const searchBycompletedDate =
                formikRef.current.values.search_datepicker_completeddate;
            const searchFromUploadDate = new Date(searchByuploadDate);
            const searchFromCompletedDate = new Date(searchBycompletedDate);

            const stringUploadDate =
                Number.isNaN(Date.parse(searchByuploadDate)) === false &&
                typeof searchByuploadDate !== 'number'
                    ? dateFns.formatByString(searchFromUploadDate, 'yyyy-MM-dd')
                    : null;
            const stringCompletedDate =
                Number.isNaN(Date.parse(searchBycompletedDate)) === false &&
                typeof searchBycompletedDate !== 'number'
                    ? dateFns.formatByString(
                          searchFromCompletedDate,
                          'yyyy-MM-dd'
                      )
                    : null;

            TemplateService.saveSavedTemplate({
                query: {
                    offset:
                        state.reduxInitValues.offset &&
                        typeof state.reduxInitValues.offset === 'number'
                            ? state.reduxInitValues.offset
                            : 1,
                    limit:
                        state.rowsPerPage &&
                        typeof state.rowsPerPage === 'number'
                            ? state.rowsPerPage
                            : 10,
                    sort: state.sortBy ? state.sortBy : undefined,
                    packetStatus:
                        Array.isArray(state.packetStatus) &&
                        state.packetStatus.length > 0
                            ? state.packetStatus
                            : undefined,
                    packetType:
                        Array.isArray(state.packetType) &&
                        state.packetType.length > 0
                            ? state.packetType
                            : undefined,
                    loanNumber: formikRef.current.values.search_loan
                        ? formikRef.current.values.search_loan
                        : undefined,
                    binNumber: formikRef.current.values.search_bin
                        ? formikRef.current.values.search_bin
                        : undefined,
                    operatorId: formikRef.current.values.search_operator
                        ? formikRef.current.values.search_operator
                        : undefined,
                    cm9Number: formikRef.current.values.search_cm9
                        ? formikRef.current.values.search_cm9
                        : undefined,
                    clientName: formikRef.current.values.search_client
                        ? formikRef.current.values.search_client
                        : undefined,
                    uploadDate:
                        stringUploadDate !== null
                            ? stringUploadDate
                            : undefined,
                    completedDate:
                        stringCompletedDate !== null
                            ? stringCompletedDate
                            : undefined,
                    slaDaysLeft: checkedBySLADate
                        ? formikRef.current.values.search_sladate
                        : undefined,
                    uploadAge: checkedByUploadAge
                        ? formikRef.current.values.search_uploadage
                        : undefined,
                },
                type: 'global',
            })
                .then((response) => {
                    const {
                        data: { data: contentTemplate },
                    } = response;
                    const { templateId: contentTemplateId } = contentTemplate;
                    dispatch(
                        ProfileActions.setGloballyTemplateId(contentTemplateId)
                    );
                    setSavingGloballyTemplate(false);
                    Utils.handleSuccessResponse(response);
                })
                .catch((response) => {
                    setSavingGloballyTemplate(false);
                    if (
                        response !== null &&
                        response instanceof AxiosError &&
                        response.code === 'ERR_NETWORK'
                    ) {
                        Toast.showErrorMessage(
                            'No internet connection, Please try again!'
                        );
                    } else {
                        Utils.handleErrorResponse(response);
                    }
                });
        }
    }, [
        checkedBySLADate,
        checkedByUploadAge,
        dispatch,
        formikRef,
        isAbleSavingTemplate,
        state.packetStatus,
        state.packetType,
        state.reduxInitValues.offset,
        state.rowsPerPage,
        state.sortBy,
        userInfo.globalDashboardTemplateEnabled,
    ]);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const handleResetCustomTemplate = React.useCallback(
        async (values: any, formik: any) => {
            setSubmit(true);
            // eslint-disable-next-line no-nested-ternary
            const templateId = userInfo.globalDashboardTemplateEnabled
                ? userInfo.globalDashboardTemplateId
                : userInfo.customDashboardTemplateEnabled
                ? userInfo.customDashboardTemplateId
                : userInfo.defaultDashboardTemplateId;

            const templateResponse = await TemplateService.getTemplate({
                templateId,
            })
                .then((response: any) => response)
                .catch((error) => {
                    Utils.handleErrorResponse(error);
                    return false;
                });
            if (templateResponse !== false) {
                const { query } = templateResponse.data.data;
                dispatch(
                    setSidebarDashboard({
                        reduxInitValues: query,

                        initializeFromReload: false,
                    })
                );
            }

            handleReset(formik, resetSearch);
        },
        [
            dispatch,
            handleReset,
            resetSearch,
            userInfo.customDashboardTemplateEnabled,
            userInfo.customDashboardTemplateId,
            userInfo.defaultDashboardTemplateId,
            userInfo.globalDashboardTemplateEnabled,
            userInfo.globalDashboardTemplateId,
        ]
    );

    const handleResetGloballyTemplate = React.useCallback(() => {
        setResetGloballyTemplate(true);
        const templateId = userInfo.globalDashboardTemplateId;
        TemplateService.resetSavedTemplate({ templateId, type: 'global' })
            .then(async (response) => {
                const templateId = userInfo.customDashboardTemplateEnabled
                    ? userInfo.customDashboardTemplateId
                    : userInfo.defaultDashboardTemplateId;
                dispatch(BaseAppActions.resetSidebarDashboardTheme(true));
                const templateResponse = await TemplateService.getTemplate({
                    templateId,
                })
                    .then((response: any) => response)
                    .catch((error) => {
                        Utils.handleErrorResponse(error);
                        return false;
                    });
                if (templateResponse !== false) {
                    const { query } = templateResponse.data.data;

                    dispatch(
                        BaseAppActions.setSidebarDashboardFromInterceptor(query)
                    );
                }

                dispatch(ProfileActions.setGloballyTemplateStatus(false));
                setResetGloballyTemplate(false);
                Utils.handleSuccessResponse(response);
            })
            .catch((response) => {
                setResetGloballyTemplate(false);
                if (
                    response !== null &&
                    response instanceof AxiosError &&
                    response.code === 'ERR_NETWORK'
                ) {
                    Toast.showErrorMessage(
                        'No internet connection, Please try again!'
                    );
                } else {
                    Utils.handleErrorResponse(response);
                }
            });
    }, [
        dispatch,
        userInfo.customDashboardTemplateEnabled,
        userInfo.customDashboardTemplateId,
        userInfo.defaultDashboardTemplateId,
        userInfo.globalDashboardTemplateId,
    ]);

    useLayoutEffect(() => {
        if (userInfo.globalDashboardTemplateEnabled) {
            formikTilesRef.current?.setFieldValue('status', [true, false]);
        } else {
            formikTilesRef.current?.setFieldValue('status', [false, true]);
        }
    }, []);

    return (
        <Box className="side-menu-filter-and-sorting">
            <Box className="menu-container">
                <ButtonComp
                    className="action-button"
                    type="success"
                    fullWidth
                    disabled={DashboardMetaProps?.isNonRetry === false}
                    onClick={() => {
                        DashboardMetaProps?.setRefreshDashboard(true);
                        DashboardMetaProps?.setNonRetry(false);
                    }}
                    aria-haspopup="dialog"
                    // endIcon={
                    //     <Badge badgeContent={4} color="info">
                    //         <RefreshIcon color="secondary" />
                    //     </Badge>
                    // }
                >
                    Refresh
                </ButtonComp>
                <Typography variant="h3">Filters & Search</Typography>

                {/* <OrganisationList {...props} /> */}
                <Box className="menus">
                    <Box className="sort-by-container">
                        <Box
                            className={
                                !openSortByMenu
                                    ? 'sort-by-menu'
                                    : 'sort-by-menu open-menu'
                            }
                            onClick={() => {
                                setOpenSortByMenu(!openSortByMenu);
                            }}
                            aria-expanded={openSortByMenu}
                            role="button"
                            aria-controls="panel-sort-by-dashboard-sidebar"
                            id="sort-by-dashboard-sidebar"
                        >
                            <Box>
                                <Typography
                                    className="sort-by-heading"
                                    variant="h4"
                                    data-testid="sort-by-test"
                                >
                                    Sort by
                                </Typography>
                            </Box>
                            <Box>
                                {!openSortByMenu && (
                                    <ArrowDropDownIcon className="icon-drop-down-color down" />
                                )}
                                {openSortByMenu && (
                                    <ArrowDropDownIcon className="icon-drop-down-color up" />
                                )}
                            </Box>
                        </Box>
                        <Collapse
                            in={openSortByMenu}
                            className="open-menu"
                            role="region"
                            id="panel-sort-by-dashboard-sidebar"
                            aria-labelledby="sort-by-dashboard-sidebar"
                        >
                            <Box className="menu-list">
                                <FormControl id="sort-by-radio-group">
                                    <FormLabel
                                        id="radio-buttons-group-label-sortby"
                                        hidden
                                    >
                                        Sort by
                                    </FormLabel>
                                    <RadioGroup
                                        aria-labelledby="radio-buttons-group-label-sortby"
                                        defaultValue="oldestToNew"
                                        name="radio-buttons-group-sortby"
                                        value={state.sortBy}
                                        onChange={handleChangeSortBy}
                                    >
                                        <AppOutlinedRadioInput
                                            value="oldestToNew"
                                            label="Oldest to new"
                                        />
                                        <AppOutlinedRadioInput
                                            value="dateOfUpload"
                                            label="New to oldest"
                                        />
                                        {/* <AppOutlinedRadioInput
                                            value="desDaysLeftToSLA"
                                            label="Days left to SLA"
                                        />
                                        <AppOutlinedRadioInput
                                            value="daysLeftToSLA"
                                            label="Days overdue"
                                        />
                                        <AppOutlinedRadioInput
                                            value="uploadAge"
                                            label="Upload age"
                                        />
                                        <AppOutlinedRadioInput
                                            value="escalatedAge"
                                            label="Escalated age"
                                        />
                                        <AppOutlinedRadioInput
                                            value="desEscalatedAge"
                                            label="Original age"
                                        />
                                        <AppOutlinedRadioInput
                                            value="dateCompleted"
                                            label="Date Completed"
                                        />
                                        <AppOutlinedRadioInput
                                            value="desDateCompleted"
                                            label="Date Started"
                                        /> */}
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                        </Collapse>
                    </Box>

                    <Box className="search-by-container">
                        <Box
                            className={
                                !openSearchByMenu
                                    ? 'search-by-menu'
                                    : 'search-by-menu open-menu'
                            }
                            onClick={() => {
                                setOpenSearchMenu(!openSearchByMenu);
                            }}
                            aria-expanded={openSearchByMenu}
                            role="button"
                            aria-controls="panel-search-by-dashboard-sidebar"
                            id="search-by-dashboard-sidebar"
                        >
                            <Box>
                                <Typography
                                    className="search-by-heading"
                                    variant="h4"
                                    data-testid="search-by-test"
                                >
                                    Search by
                                </Typography>
                            </Box>
                            <Box>
                                {!openSearchByMenu && (
                                    <ArrowDropDownIcon className="icon-drop-down-color down" />
                                )}
                                {openSearchByMenu && (
                                    <ArrowDropDownIcon className="icon-drop-down-color up" />
                                )}
                            </Box>
                        </Box>
                        <Collapse
                            in={openSearchByMenu}
                            className="open-menu"
                            role="region"
                            id="panel-search-by-dashboard-sidebar"
                            aria-labelledby="search-by-dashboard-sidebar"
                        >
                            <Formik
                                initialValues={{
                                    search_loan: state.searchValues.loanNumber,
                                    search_bin: state.searchValues.binNumber,
                                    search_client:
                                        state.searchValues.clientName,
                                    search_operator:
                                        state.searchValues.operatorId,
                                    search_cm9: state.searchValues.cm9Number,
                                    search_datepicker_uploaddate:
                                        state.searchValues.uploadDate,
                                    search_datepicker_completeddate:
                                        state.searchValues.completedDateSearch,
                                    search_sladate:
                                        state.searchValues.slaDaysLeft,
                                    search_uploadage:
                                        state.searchValues.uploadAge,
                                }}
                                enableReinitialize={false}
                                onSubmit={(formValues, formik) => {
                                    setState((prevState: any) => ({
                                        ...prevState,
                                        page: 0,
                                    }));
                                    reqFilterPacket(
                                        formValues.search_loan,
                                        formValues.search_bin,
                                        formValues.search_client,
                                        formValues.search_operator,
                                        formValues.search_cm9,
                                        formValues.search_datepicker_uploaddate,
                                        formValues.search_datepicker_completeddate,
                                        parseInt(formValues.search_sladate, 10),
                                        parseInt(
                                            formValues.search_uploadage,
                                            10
                                        ),
                                        formik
                                    );
                                }}
                                innerRef={formikRef}
                            >
                                {({ handleSubmit }) => (
                                    <>
                                        <Box className="menu-list">
                                            <FormControl id="search-by-radio-group">
                                                <FormLabel
                                                    id="radio-buttons-group-label-search"
                                                    hidden
                                                >
                                                    Search by
                                                </FormLabel>
                                                <FormGroup
                                                    role="group"
                                                    aria-labelledby="radio-buttons-group-label-search"
                                                    // defaultValue="cmp9Number"
                                                    // name="radio-buttons-group-search"
                                                    // value={state.searchBy}
                                                >
                                                    {/* <AppOutlinedRadioInput
                                            value="cmp9Number"
                                            label="CM9 Record Number"
                                        /> */}

                                                    <AppRadioBox
                                                        checked={checkedByLoan}
                                                        color="primary"
                                                        value="loanNumber"
                                                        label="Envelope Number"
                                                        onChange={() => {
                                                            if (
                                                                checkedByLoan ===
                                                                true
                                                            ) {
                                                                formikRef.current?.setFieldValue(
                                                                    'search_loan',
                                                                    ''
                                                                );
                                                                handleSubmit();
                                                            }
                                                            setByLoan(
                                                                !checkedByLoan
                                                            );
                                                        }}
                                                    />
                                                    {checkedByLoan && (
                                                        <AppFormikTextField
                                                            outerLabel
                                                            name="search_loan"
                                                            size="small"
                                                            placeholder="Type here"
                                                            onEnter={
                                                                handleSubmit
                                                            }
                                                            autoFocus={
                                                                DashboardMetaProps?.isTableHeadingContentFocus ===
                                                                false
                                                            }
                                                            autoComplete="off"
                                                        />
                                                    )}
                                                    <AppRadioBox
                                                        checked={checkedByBin}
                                                        color="primary"
                                                        value="binNumber"
                                                        label="Reference Number"
                                                        onChange={() => {
                                                            if (
                                                                checkedByBin ===
                                                                true
                                                            ) {
                                                                formikRef.current?.setFieldValue(
                                                                    'search_bin',
                                                                    ''
                                                                );
                                                                handleSubmit();
                                                            }
                                                            setByBin(
                                                                !checkedByBin
                                                            );
                                                        }}
                                                    />
                                                    {checkedByBin && (
                                                        <AppFormikTextField
                                                            outerLabel
                                                            name="search_bin"
                                                            size="small"
                                                            placeholder="Type here"
                                                            onEnter={
                                                                handleSubmit
                                                            }
                                                            autoFocus={
                                                                DashboardMetaProps?.isTableHeadingContentFocus ===
                                                                false
                                                            }
                                                            autoComplete="off"
                                                        />
                                                    )}
                                                    <AppRadioBox
                                                        checked={
                                                            checkedByClient
                                                        }
                                                        color="primary"
                                                        value="clientName"
                                                        label="Checklists Name"
                                                        onChange={() => {
                                                            if (
                                                                checkedByClient ===
                                                                true
                                                            ) {
                                                                formikRef.current?.setFieldValue(
                                                                    'search_client',
                                                                    ''
                                                                );
                                                                handleSubmit();
                                                            }
                                                            setByClient(
                                                                !checkedByClient
                                                            );
                                                        }}
                                                    />
                                                    {checkedByClient && (
                                                        <AppFormikTextField
                                                            outerLabel
                                                            name="search_client"
                                                            size="small"
                                                            placeholder="Type here"
                                                            onEnter={
                                                                handleSubmit
                                                            }
                                                            autoFocus={
                                                                DashboardMetaProps?.isTableHeadingContentFocus ===
                                                                false
                                                            }
                                                            autoComplete="off"
                                                        />
                                                    )}
                                                    <AppRadioBox
                                                        checked={
                                                            checkedByOperator
                                                        }
                                                        color="primary"
                                                        value="operatorId"
                                                        label="Member ID"
                                                        onChange={() => {
                                                            if (
                                                                checkedByOperator ===
                                                                true
                                                            ) {
                                                                formikRef.current?.setFieldValue(
                                                                    'search_operator',
                                                                    ''
                                                                );
                                                                handleSubmit();
                                                            }
                                                            setByOperator(
                                                                !checkedByOperator
                                                            );
                                                        }}
                                                    />
                                                    {checkedByOperator && (
                                                        <AppFormikTextField
                                                            outerLabel
                                                            name="search_operator"
                                                            size="small"
                                                            placeholder="Type here"
                                                            onEnter={
                                                                handleSubmit
                                                            }
                                                            autoFocus={
                                                                DashboardMetaProps?.isTableHeadingContentFocus ===
                                                                false
                                                            }
                                                            autoComplete="off"
                                                        />
                                                    )}
                                                    <AppRadioBox
                                                        checked={checkedByCM9}
                                                        color="primary"
                                                        value="cm9"
                                                        label="Reference Number"
                                                        onChange={() => {
                                                            if (
                                                                checkedByCM9 ===
                                                                true
                                                            ) {
                                                                formikRef.current?.setFieldValue(
                                                                    'search_cm9',
                                                                    ''
                                                                );
                                                                handleSubmit();
                                                            }
                                                            setByCM9(
                                                                !checkedByCM9
                                                            );
                                                        }}
                                                    />
                                                    {checkedByCM9 && (
                                                        <AppFormikTextField
                                                            outerLabel
                                                            name="search_cm9"
                                                            size="small"
                                                            placeholder="Type here"
                                                            onEnter={
                                                                handleSubmit
                                                            }
                                                            autoFocus
                                                            autoComplete="off"
                                                        />
                                                    )}
                                                    <AppRadioBox
                                                        checked={
                                                            checkedByUploadDate
                                                        }
                                                        color="primary"
                                                        value="uploadedDate"
                                                        label="Date of upload"
                                                        onChange={() => {
                                                            if (
                                                                checkedByUploadDate ===
                                                                true
                                                            ) {
                                                                formikRef.current?.setFieldValue(
                                                                    'search_datepicker_uploaddate',
                                                                    ''
                                                                );
                                                                handleSubmit();
                                                            }
                                                            setByUploadDate(
                                                                !checkedByUploadDate
                                                            );
                                                        }}
                                                    />
                                                    {checkedByUploadDate && (
                                                        <AppFormikDatePicker
                                                            autoFocus
                                                            name="search_datepicker_uploaddate"
                                                            testid="datepicker-dropdown"
                                                            InputProps={{
                                                                name: 'search_datepicker_uploaddate',
                                                                'aria-labelledby':
                                                                    'uploadDate-datepicker-label',
                                                                notched: false,
                                                            }}
                                                            value={undefined}
                                                            onChange={() =>
                                                                setRippleFormikState(
                                                                    true
                                                                )
                                                            }
                                                            onChangeDate={() =>
                                                                setRippleFormikState(
                                                                    true
                                                                )
                                                            }
                                                            onAccepted={() => {
                                                                setRippleFormikState(
                                                                    true
                                                                );
                                                            }}
                                                            onClose={() => {
                                                                setRippleFormikState(
                                                                    true
                                                                );
                                                            }}
                                                            renderInput={(
                                                                props: any
                                                            ) => (
                                                                <TextField
                                                                    {...props}
                                                                />
                                                            )}
                                                            autoComplete="off"
                                                            onEnter={
                                                                handleSubmit
                                                            }
                                                        />
                                                    )}
                                                    <AppRadioBox
                                                        checked={
                                                            checkedByCompletedDate
                                                        }
                                                        color="primary"
                                                        value="completedDate"
                                                        label="Completed Date"
                                                        onChange={() => {
                                                            if (
                                                                checkedByCompletedDate ===
                                                                true
                                                            ) {
                                                                formikRef.current?.setFieldValue(
                                                                    'search_datepicker_completeddate',
                                                                    ''
                                                                );
                                                                handleSubmit();
                                                            }
                                                            setByCompletedDate(
                                                                !checkedByCompletedDate
                                                            );
                                                        }}
                                                    />
                                                    {checkedByCompletedDate && (
                                                        <AppFormikDatePicker
                                                            autoFocus
                                                            name="search_datepicker_completeddate"
                                                            testid="datepicker-dropdown"
                                                            InputProps={{
                                                                name: 'search_datepicker_completeddate',
                                                                'aria-labelledby':
                                                                    'completedDate-datepicker-label',
                                                                notched: false,
                                                            }}
                                                            value={undefined}
                                                            onChange={() =>
                                                                setRippleFormikState(
                                                                    true
                                                                )
                                                            }
                                                            onChangeDate={() =>
                                                                setRippleFormikState(
                                                                    true
                                                                )
                                                            }
                                                            onAccepted={() => {
                                                                setRippleFormikState(
                                                                    true
                                                                );
                                                            }}
                                                            onClose={() => {
                                                                setRippleFormikState(
                                                                    true
                                                                );
                                                            }}
                                                            renderInput={(
                                                                props: any
                                                            ) => (
                                                                <TextField
                                                                    {...props}
                                                                />
                                                            )}
                                                            autoComplete="off"
                                                            onEnter={
                                                                handleSubmit
                                                            }
                                                        />
                                                    )}
                                                    <AppRadioBox
                                                        checked={
                                                            checkedBySLADate
                                                        }
                                                        color="primary"
                                                        value="slaDate"
                                                        label="Days left to sla"
                                                        onChange={() => {
                                                            if (
                                                                checkedBySLADate ===
                                                                true
                                                            ) {
                                                                formikRef.current?.setFieldValue(
                                                                    'search_sladate',
                                                                    ''
                                                                );
                                                                handleSubmit();
                                                            }
                                                            setBySLADate(
                                                                !checkedBySLADate
                                                            );
                                                        }}
                                                    />
                                                    {checkedBySLADate && (
                                                        <AppFormikTextFieldNumber
                                                            outerLabel
                                                            name="search_sladate"
                                                            size="small"
                                                            placeholder="Type here"
                                                            positiveLookAhead
                                                            onEnter={
                                                                handleSubmit
                                                            }
                                                            autoFocus
                                                            autoComplete="off"
                                                        />
                                                    )}
                                                    <AppRadioBox
                                                        checked={
                                                            checkedByUploadAge
                                                        }
                                                        color="primary"
                                                        value="uploadAge"
                                                        label="Upload Age"
                                                        onChange={() => {
                                                            if (
                                                                checkedByUploadAge ===
                                                                true
                                                            ) {
                                                                formikRef.current?.setFieldValue(
                                                                    'search_uploadage',
                                                                    ''
                                                                );
                                                                handleSubmit();
                                                            }
                                                            setByUploadAge(
                                                                !checkedByUploadAge
                                                            );
                                                        }}
                                                    />
                                                    {checkedByUploadAge && (
                                                        <AppFormikTextFieldNumber
                                                            outerLabel
                                                            name="search_uploadage"
                                                            size="small"
                                                            positiveLookAhead
                                                            placeholder="Recently uploaded days"
                                                            onEnter={
                                                                handleSubmit
                                                            }
                                                            autoFocus
                                                            autoComplete="off"
                                                        />
                                                    )}
                                                </FormGroup>
                                            </FormControl>
                                        </Box>
                                        <Box className="menu-list">
                                            <Box className="search-by-textual">
                                                <form autoComplete="off">
                                                    <Grid item xs={12}>
                                                        {/* <AppPrimaryButton
                                                            className="btn-small"
                                                            fullWidth
                                                            title="Submit"
                                                            isLoading={
                                                                isSubmitting
                                                            }
                                                            loadingSize={22}
                                                            disabled={
                                                                (!checkedByBin &&
                                                                    !checkedByClient &&
                                                                    !checkedByLoan &&
                                                                    !checkedByOperator &&
                                                                    !checkedByCM9 &&
                                                                    !checkedByUploadDate &&
                                                                    !checkedByCompletedDate &&
                                                                    !checkedBySLADate &&
                                                                    !checkedByUploadAge) ||
                                                                isSubmitting ||
                                                                !isValid
                                                            }
                                                            onClick={
                                                                handleSubmit
                                                            }
                                                        /> */}
                                                        <Box mt={2} />
                                                        <AppPrimaryButton
                                                            className="btn-small-neutral"
                                                            fullWidth
                                                            title="Clear"
                                                            loadingSize={22}
                                                            onClick={(ev: {
                                                                preventDefault: () => any;
                                                            }) => {
                                                                ev.preventDefault();
                                                                resetSearch();
                                                                handleChangeSearchBy(
                                                                    ''
                                                                );
                                                                reqFilterPacket(
                                                                    '',
                                                                    '',
                                                                    '',
                                                                    '',
                                                                    '',
                                                                    '',
                                                                    '',
                                                                    0,
                                                                    0,
                                                                    false
                                                                );
                                                            }}
                                                        />
                                                    </Grid>
                                                </form>
                                            </Box>
                                        </Box>
                                    </>
                                )}
                            </Formik>
                        </Collapse>
                    </Box>

                    {/* Temporary wait API */}
                    <Box className="filter-by-packet-status-container">
                        <Box
                            className={
                                !openFilterByPacketStatusMenu
                                    ? 'filter-by-packet-status-menu'
                                    : 'filter-by-packet-status-menu open-menu'
                            }
                            onClick={() => {
                                setOpenFilterPacketStatusMenu(
                                    !openFilterByPacketStatusMenu
                                );
                            }}
                            aria-expanded={openFilterByPacketStatusMenu}
                            role="button"
                            aria-controls="panel-filter-by-status-dashboard-sidebar"
                            id="filter-by-status-dashboard-sidebar"
                        >
                            <Box>
                                <Typography
                                    className="filter-by-packet-status-heading"
                                    variant="h4"
                                    data-testid="filter-by-status-test"
                                >
                                    Filter by Cross Check Status
                                </Typography>
                            </Box>
                            <Box>
                                {!openFilterByPacketStatusMenu && (
                                    <ArrowDropDownIcon className="icon-drop-down-color down" />
                                )}
                                {openFilterByPacketStatusMenu && (
                                    <ArrowDropDownIcon className="icon-drop-down-color up" />
                                )}
                            </Box>
                        </Box>
                        <Collapse
                            in={openFilterByPacketStatusMenu}
                            className="open-menu"
                            role="region"
                            id="panel-filter-by-status-dashboard-sidebar"
                            aria-labelledby="filter-by-status-dashboard-sidebar"
                        >
                            <Box className="menu-list">
                                <FormControl id="filter-by-packet-status-radio-group">
                                    <FormLabel
                                        id="radio-buttons-group-label-filter-by-packet-status"
                                        hidden
                                    >
                                        Filter by Cross Check Status
                                    </FormLabel>
                                    <FormGroup
                                        aria-labelledby="radio-buttons-group-label-filter-by-packet-status"
                                        role="group"
                                    >
                                        {checkboxStatus
                                            .filter(
                                                (e) =>
                                                    (e.value !== 'escalated' &&
                                                        role === 'operator') ||
                                                    role !== 'operator'
                                            )
                                            .map((checkbox) => (
                                                <AppRadioBox
                                                    checked={
                                                        state.packetStatus
                                                            .length === 0
                                                            ? checkbox.value ===
                                                              'viewall'
                                                            : state.packetStatus.includes(
                                                                  checkbox.value
                                                              )
                                                    }
                                                    color="primary"
                                                    value={checkbox.value}
                                                    onChange={
                                                        handleChangePacketStatus
                                                    }
                                                    label={checkbox.label}
                                                />
                                            ))}
                                    </FormGroup>
                                </FormControl>
                            </Box>
                        </Collapse>
                    </Box>

                    <Box className="filter-by-packet-type-container">
                        <Box
                            className={
                                !openFilterByPacketTypeMenu
                                    ? 'filter-by-packet-type-menu'
                                    : 'filter-by-packet-type-menu open-menu'
                            }
                            onClick={() => {
                                setOpenFilterPacketTypeMenu(
                                    !openFilterByPacketTypeMenu
                                );
                            }}
                            aria-expanded={openFilterByPacketStatusMenu}
                            role="button"
                            aria-controls="panel-filter-by-type-dashboard-sidebar"
                            id="filter-by-type-dashboard-sidebar"
                        >
                            <Box>
                                <Typography
                                    className="filter-by-packet-type-heading"
                                    variant="h4"
                                    data-testid="filter-by-type-test"
                                >
                                    Filter by Cross Check Type
                                </Typography>
                            </Box>
                            <Box>
                                {!openFilterByPacketTypeMenu && (
                                    <ArrowDropDownIcon className="icon-drop-down-color down" />
                                )}
                                {openFilterByPacketTypeMenu && (
                                    <ArrowDropDownIcon className="icon-drop-down-color up" />
                                )}
                            </Box>
                        </Box>
                        <Collapse
                            in={openFilterByPacketTypeMenu}
                            className="open-menu"
                            role="region"
                            id="panel-filter-by-type-dashboard-sidebar"
                            aria-labelledby="filter-by-type-dashboard-sidebar"
                        >
                            <Box className="menu-list">
                                <FormControl id="filter-by-packet-type-radio-group">
                                    <FormLabel
                                        id="radio-buttons-group-label-filter-by-packet-type"
                                        hidden
                                    >
                                        Filter by Cross Check Type
                                    </FormLabel>
                                    <FormGroup aria-labelledby="radio-buttons-group-label-filter-by-packet-type">
                                        {checkboxType.map((checkbox) => (
                                            <AppRadioBox
                                                checked={
                                                    state.packetType.length ===
                                                    0
                                                        ? checkbox.value ===
                                                          'viewall'
                                                        : state.packetType.includes(
                                                              checkbox.value
                                                          )
                                                }
                                                color="primary"
                                                value={checkbox.value}
                                                onChange={
                                                    handleChangePacketType
                                                }
                                                label={checkbox.label}
                                            />
                                        ))}
                                    </FormGroup>
                                </FormControl>
                            </Box>
                        </Collapse>
                    </Box>

                    <Box className="filter-by-packet-type-container">
                        <Box
                            className={
                                !openGloballyTemplate
                                    ? 'filter-by-packet-type-menu'
                                    : 'filter-by-packet-type-menu open-menu'
                            }
                            aria-expanded={openGloballyTemplate}
                            role="button"
                            aria-controls="panel-filter-by-type-dashboard-sidebar"
                            id="filter-by-type-dashboard-sidebar"
                        >
                            <Box>
                                <Typography
                                    className="filter-by-packet-type-heading"
                                    variant="h4"
                                    data-testid="filter-by-type-test"
                                >
                                    Global Template
                                </Typography>
                            </Box>
                        </Box>
                        <Collapse
                            in={openGloballyTemplate}
                            className="open-menu"
                            role="region"
                            id="panel-filter-by-type-dashboard-sidebar"
                            aria-labelledby="filter-by-type-dashboard-sidebar"
                        >
                            <Stack
                                direction="column"
                                spacing={2}
                                className="stack-template-button"
                            >
                                <Stack direction="row" spacing={1}>
                                    <Typography className="label-status">
                                        Status :
                                    </Typography>
                                    <Typography className="status-global-template">
                                        {userInfo.globalDashboardTemplateEnabled
                                            ? 'Active'
                                            : 'Inactive'}
                                    </Typography>
                                </Stack>
                                {role === 'clientManager' && (
                                    <Stack direction="row" spacing={2}>
                                        <Tooltip
                                            title="Global template is in the active state."
                                            disableHoverListener={
                                                userInfo.globalDashboardTemplateEnabled ===
                                                false
                                            }
                                            placement="top"
                                            arrow
                                        >
                                            <span>
                                                <AppPrimaryButton
                                                    className="btn-small-neutral save-globally-template"
                                                    fullWidth
                                                    title="Enable"
                                                    loadingSize={22}
                                                    isLoading={
                                                        isSavingGloballyTemplate
                                                    }
                                                    onClick={
                                                        handleGloballySaveTemplate
                                                    }
                                                />
                                            </span>
                                        </Tooltip>

                                        <AppPrimaryButton
                                            className="btn-small reset-globally-template"
                                            fullWidth
                                            title="Disable"
                                            loadingSize={22}
                                            isLoading={isResetGloballyTemplate}
                                            disabled={
                                                userInfo.globalDashboardTemplateEnabled ===
                                                false
                                            }
                                            onClick={
                                                handleResetGloballyTemplate
                                            }
                                        />
                                    </Stack>
                                )}
                            </Stack>
                        </Collapse>
                    </Box>
                    <Box className="filter-by-packet-type-container">
                        <Box
                            className={
                                !openCustomTemplate
                                    ? 'filter-by-packet-type-menu'
                                    : 'filter-by-packet-type-menu open-menu'
                            }
                            aria-expanded={openCustomTemplate}
                            role="button"
                            aria-controls="panel-filter-by-type-dashboard-sidebar"
                            id="filter-by-type-dashboard-sidebar"
                        >
                            <Box>
                                {/* <Typography
                                    className="filter-by-packet-type-heading"
                                    variant="h4"
                                    data-testid="filter-by-type-test"
                                >
                                    Custom Template
                                </Typography> */}
                            </Box>
                        </Box>
                        <Collapse
                            in={openCustomTemplate}
                            className="open-menu"
                            role="region"
                            id="panel-filter-by-type-dashboard-sidebar"
                            aria-labelledby="filter-by-type-dashboard-sidebar"
                        >
                            <Stack
                                direction="column"
                                spacing={2}
                                className="stack-template-button"
                            >
                                <Stack direction="row" spacing={2}>
                                    <Tooltip
                                        title="Global template is in the active state."
                                        disableHoverListener={
                                            userInfo.globalDashboardTemplateEnabled ===
                                            false
                                        }
                                        placement="top"
                                        arrow
                                    >
                                        <span>
                                            <AppPrimaryButton
                                                className="btn-small-neutral save-template"
                                                fullWidth
                                                title="Save"
                                                loadingSize={22}
                                                isLoading={isSavingTemplate}
                                                disabled={
                                                    isSavingTemplate ||
                                                    isAbleSavingTemplate ===
                                                        false ||
                                                    userInfo.globalDashboardTemplateEnabled ===
                                                        true
                                                }
                                                onClick={handleSaveTemplate}
                                            />
                                        </span>
                                    </Tooltip>
                                    <Formik
                                        initialValues={{
                                            smallInput: '',
                                        }}
                                        enableReinitialize
                                        onSubmit={handleResetCustomTemplate}
                                    >
                                        {({ handleSubmit, isValid }) => (
                                            <form autoComplete="off">
                                                <AppPrimaryButton
                                                    className="btn-small reset-template"
                                                    fullWidth
                                                    title="Reset"
                                                    isLoading={isSubmitting}
                                                    loadingSize={22}
                                                    disabled={
                                                        isSubmitting ||
                                                        !isValid ||
                                                        isAbleSavingTemplate ===
                                                            false
                                                    }
                                                    onClick={handleSubmit}
                                                />
                                            </form>
                                        )}
                                    </Formik>
                                </Stack>
                            </Stack>
                        </Collapse>
                    </Box>

                    <Box className="container-search">
                        <Stack
                            direction="column"
                            spacing={2}
                            className="stack-template-button"
                        >
                            {false && (
                                <AppPrimaryButton
                                    className="btn-small"
                                    fullWidth
                                    title="Reset Share Template"
                                    loadingSize={22}
                                    onClick={() =>
                                        setShowResetShareTemplateDialog(true)
                                    }
                                />
                            )}

                            <ButtonGroup
                                variant="text"
                                aria-label="Button group with a nested menu"
                            >
                                <AppPrimaryButton
                                    className="btn-small-neutral share-template"
                                    fullWidth
                                    title="Share Template"
                                    loadingSize={22}
                                    disabled={isShareTemplateAllowed}
                                    onClick={actionOnShareTemplate}
                                    aria-haspopup="dialog"
                                />
                                {isShareTemplateAllowed && (
                                    <Tooltip
                                        placement="right-start"
                                        title="Global Template has been implemented by Client Manager. Templates can only be shared when global template is disabled."
                                    >
                                        <IconButton>
                                            <InfoIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </ButtonGroup>

                            {/* <Formik
                                initialValues={{
                                    smallInput: '',
                                }}
                                enableReinitialize
                                onSubmit={(formValues, formik) => {
                                    setSubmit(true);
                                    handleReset(formik, resetSearch);
                                }}
                            >
                                {({ handleSubmit, isValid }) => (
                                    <form autoComplete="off">
                                        <Box marginBottom={2}>
                                            {(checkedByBin ||
                                                checkedByClient ||
                                                checkedByLoan ||
                                                checkedByOperator ||
                                                checkedByCM9 ||
                                                checkedByUploadDate ||
                                                checkedByCompletedDate ||
                                                checkedBySLADate ||
                                                checkedByUploadAge ||
                                                state.searchBy ||
                                                state.sortBy ||
                                                state.textField ||
                                                state.packetStatus.length > 0 ||
                                                state.packetType.length >
                                                    0) && (
                                                <AppPrimaryButton
                                                    className="btn-small"
                                                    fullWidth
                                                    title="Reset Current Filter"
                                                    isLoading={isSubmitting}
                                                    loadingSize={22}
                                                    disabled={
                                                        isSubmitting || !isValid
                                                    }
                                                    onClick={handleSubmit}
                                                />
                                            )}
                                        </Box>
                                    </form>
                                )}
                            </Formik> */}
                        </Stack>
                    </Box>
                </Box>
            </Box>
            <OverrideGlobalSavingModal
                callbackClosingModal={() => console.log('closing')}
                callbackOpenModal={() => console.log('closing two')}
                callbackFinishOverride={handleOverrideGloballySaveTemplate}
                ref={overrideModal}
            />
            {showShareTemplateDialog && (
                <ShareTemplateFormDialog
                    showForm={showShareTemplateDialog}
                    onCloseForm={onCloseShareTemplate}
                    profileState={profileState}
                />
            )}
            {showResetShareTemplateDialog && (
                <ResetShareTemplateFormDialog
                    showForm={showResetShareTemplateDialog}
                    onCloseForm={onCloseResetShareTemplate}
                    profileState={profileState}
                />
            )}
        </Box>
    );
};

const mapStateToProps = (state: any): any => ({
    profileState: state.profileState,
    authState: state.authState,
    baseAppState: state.baseAppState,
});

export default connect(mapStateToProps, null)(FilterSidebar);
